module.exports = __webpack_public_path__ + "static/hero5-app2-ec6979dd3c3c43916dbd4cbb6856544b.png";